import Breadcrumb from "components/Common/Breadcrumb2"
import OffCanvasFilter from "components/OffCanvasFilter/OffCanvasFilter"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { withTranslation } from "react-i18next"
import { Col, Container, Row } from "reactstrap"
import Embossing from "./Components/Embossing"

const AguardandoEmbossing = props => {
  document.title = "Aguardando Embossing | Sensetek"

  const [showFilter, setShowFilter] = useState(false)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Aguardando Embossing")}
            breadcrumbItems={[{ title: props.t("Indicadores"), path: "#" }]}
          />
          <Row>
            <Col className="d-flex flex-row-reverse">
              <button
                className="btn filter-item noti-icon right-bar-toggle text-end"
                type="button"
                onClick={() => {
                  setShowFilter(true)
                }}
              >
                <i className="bx bx-filter" />
              </button>
              <OffCanvasFilter
                showFilter={showFilter}
                setShowFilter={setShowFilter}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Embossing />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
AguardandoEmbossing.propTypes = {
  t: PropTypes.any,
}
export default withTranslation()(AguardandoEmbossing)
